import React from "react";
//import "../Supporting.scss"
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

interface Props {
  title: string;
  value: string | Date | null;
  attrName: any;
  value_update: Function;
  error_message: string;
  warn_status: boolean;
  class_name: string;
}

const DatePicker: React.FC<Props> = ({
  title,
  value,
  value_update,
  attrName,
  error_message,
  warn_status,
  class_name,
}) => {
  return (
    <div className={class_name}>
      <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
        <MobileDatePicker
          label={title}
          value={value}
          onChange={(e) => {
            value_update(attrName, e);
          }}
          renderInput={(params) => <TextField fullWidth {...params} />}
          inputFormat="dd/MM/yyyy"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end" onClick={() => {}}>
                  <CalendarMonthOutlinedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </LocalizationProvider>
      {warn_status == true ? (
        <span className="error">{error_message}</span>
      ) : null}
    </div>
  );
};

export default DatePicker;
